
































































































































































import { Component, Vue } from 'vue-property-decorator'
import { RequestPaging } from '@/utils/util'
import { apiServiceLists, apiServiceStatus, apiServiceDelete } from '@/api/service'
import { apiWorkOrderTypeAllList } from '@/api/work_order'

@Component
export default class ServiceList extends Vue {
    queryObj: any = {
      keyword: '',
      work_order_type_id: '',
      status: ''
    }

    tableData: any[] = []
    loading = false
    workOrderTypes: any[] = []

    pager = new RequestPaging()

    /** 与 ServiceLists 文档一致：仅传有效筛选条件，避免空字符串参与校验 */
    getServiceListFilterParams (): Record<string, string | number> {
      const q = this.queryObj
      const params: Record<string, string | number> = {}
      const kw = q.keyword != null ? String(q.keyword).trim() : ''
      if (kw) params.keyword = kw
      if (q.work_order_type_id !== '' && q.work_order_type_id != null) {
        params.work_order_type_id = Number(q.work_order_type_id)
      }
      if (q.status !== '' && q.status != null && q.status !== undefined) {
        params.status = Number(q.status)
      }
      return params
    }

    getList (page?: number): void {
      page && (this.pager.page = page)
      this.loading = true
      this.pager
        .request({
          callback: apiServiceLists,
          params: this.getServiceListFilterParams()
        })
        .then((res: any) => {
          this.tableData = res.lists || []
        })
        .finally(() => {
          this.loading = false
        })
    }

    getWorkOrderTypes (): void {
      apiWorkOrderTypeAllList()
        .then((res: any) => {
          this.workOrderTypes = res.lists || res || []
        })
    }

    handleReset () {
      this.queryObj = {
        keyword: '',
        work_order_type_id: '',
        status: ''
      }
      this.getList(1)
    }

    handleAdd () {
      this.$router.push('/work_order/service/add')
    }

    handleEdit (row: any) {
      this.$router.push({ path: '/work_order/service/edit', query: { id: row.id } })
    }

    handleToggleStatus (row: any) {
      const action = row.status ? '停用' : '启用'
      this.$confirm(`确定要${action}该服务吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        apiServiceStatus({
          id: row.id,
          status: row.status ? 0 : 1
        }).then(() => {
          this.getList()
        })
      })
    }

    handleDelete (row: any) {
      this.$confirm('确定要删除该服务吗？删除后将无法恢复！', '警告', {
        type: 'warning'
      }).then(() => {
        apiServiceDelete({ id: row.id }).then(() => {
          this.getList()
        })
      })
    }

    handleSizeChange (size: number) {
      this.pager.size = size
      this.getList()
    }

    handleCurrentChange (page: number) {
      this.pager.page = page
      this.getList()
    }

    // 处理图片加载错误
    handleImageError (event: Event, row: any) {
      const imgElement = event.target as HTMLImageElement
      imgElement.style.display = 'none'
      row._imageError = true
    }

    formatCurrency (value: number): string {
      if (!value) {
        return '￥0.00'
      }
      return '￥' + Number(value).toFixed(2)
    }

    created () {
      this.getList()
      this.getWorkOrderTypes()
    }

    activated () {
      this.getList()
    }
}
